import {
  initialState,
  Actions,
  State,
  GET_ALL_SESSIONS,
  GET_ALL_SESSIONS_SUCCESS,
  GET_ALL_SESSIONS_ERROR,
  RESET_GET_ALL_SESSIONS,
} from "../../types/session/all";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_ALL_SESSIONS:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case GET_ALL_SESSIONS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case GET_ALL_SESSIONS_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_GET_ALL_SESSIONS:
      return { ...initialState };
    default:
      return state;
  }
};

export default reducers;
